import { Modal } from "antd";
import LabeledInput from "../ui/LabeledInput";
import Dropdown from "../ui/Dropdown";

const EditReaderModal = ({
  visible,
  onCancel,
  onSubmit,
  formData,
  setFormData,
  dropdownOptions,
}) => {
  const handleChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  const convertToInputFormat = (dateStr) => {
    if (!dateStr) return "";

    // If already in YYYY-MM-DD format, return as is
    if (dateStr.match(/^\d{4}-\d{2}-\d{2}$/)) {
      return dateStr;
    }

    // Convert DD-MM-YYYY to YYYY-MM-DD
    const parts = dateStr.split("-");
    if (parts.length === 3) {
      return `${parts[2]}-${parts[1]}-${parts[0]}`; // YYYY-MM-DD
    }

    return "";
  };

  const convertToServerFormat = (dateStr) => {
    if (!dateStr) return "";
    const parts = dateStr.split("-");
    return `${parts[2]}-${parts[1]}-${parts[0]}`; // DD-MM-YYYY
  };

  const handleDateChange = (date) => {
    setFormData({
      ...formData,
      expiry_date: date ? date.format("YYYY-MM-DD") : null,
    });
  };
  const statusOptions = [
    { label: "Active", value: "active" },
    { label: "Expired", value: "expired" },
  ];

  const subscriptionOptions = [
    { label: "Annual", value: "Annual" },
    { label: "Trial", value: "trial" },
  ];

  return (
    <Modal
      title="Edit Reader"
      visible={visible}
      onCancel={onCancel}
      onOk={onSubmit}
      okText="Update"
      width={700}
    >
      <div className="space-y-4">
        {/* Two per row */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <LabeledInput
            label="First Name"
            value={formData.firstname}
            onChange={(e) => handleChange("firstname", e.target.value)}
          />
          <LabeledInput
            label="Last Name"
            value={formData.lastname}
            onChange={(e) => handleChange("lastname", e.target.value)}
          />
          <LabeledInput
            label="Email"
            value={formData.email}
            onChange={(e) => handleChange("email", e.target.value)}
            disabled={true}
          />
          <LabeledInput
            label="Mobile"
            value={formData.mobile}
            onChange={(e) => handleChange("mobile", e.target.value)}
          />
          <LabeledInput
            label="Job title"
            value={formData.jobtitle}
            onChange={(e) => handleChange("jobtitle", e.target.value)}
          />
          <Dropdown
            label="State"
            options={dropdownOptions.states}
            value={formData.state_id}
            onChange={(val) => handleChange("state_id", val)}
          />

          <Dropdown
            label="Status"
            options={statusOptions}
            value={formData.status}
            onChange={(val) => handleChange("status", val)}
          />

          <Dropdown
            label="Subscription"
            options={subscriptionOptions}
            value={formData.subscription_type}
            onChange={(val) => handleChange("subscription_type", val)}
          />

          <div>
            <label className="block text-sm font-medium mb-1">
              Expiry Date
            </label>
            <input
              type="date"
              value={convertToInputFormat(formData.expiry_date)}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  expiry_date: convertToServerFormat(e.target.value),
                })
              }
              className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default EditReaderModal;
